// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estructura */
.filter-container {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
}

.filter-container.hidden {
  display: none !important;
}

.filter-container.visible {
  display: flex !important;
}

.filter-button-container {
  position: relative;
  width: fit-content;
}

.filter-button {
  position: relative;
  background-color: #c1d8f1;
  color: black;
  border: none;
  border-radius: 0;
  padding: 5px 15px;
  cursor: pointer;
  outline: none;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}

.filter-button:hover {
  background-color: #b8cee6;
}

.filter-button i {
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* React select */

.filter-button-container .css-13cymwt-control {
  position: relative;
  background-color: #c1d8f1;
  color: black;
  border: none;
  border-radius: 0;
  cursor: pointer;
  outline: none;
  font-size: 15px;
  display: flex;
  justify-content: space-around;
  min-height: 30px;
}

.filter-button-container .css-1fdsijx-ValueContainer {
  color: black;
  min-width: 120px;
}

.filter-offices .css-1nmdiq5-menu {
  color: black;
  min-width: 220px;
}

.filter-button-container .css-1jqq78o-placeholder {
  color: black;
}

.filter-button-selected:hover {
  background-color: #b8cee6;
}

.filter-button-selected i {
  margin-left: 10px;
}

/* Dropdown */
.filter-menu {
  position: absolute;
  top: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  display: block;
  z-index: 1;
  width: 200px;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: opacity 0.2s ease-in-out;
}

.filter-menu label {
  display: block;
  margin-bottom: 5px;
}

.filter-menu input[type="checkbox"] {
  margin-right: 5px;
}

.filter-menu-picker {
  position: absolute;
  top: 100%;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  display: none;
  z-index: 1;
  width: 200px;
  max-height: 300px;
}

.filter-menu-picker label {
  display: block;
  margin-bottom: 5px;
}

.filter-menu-picker input[type="checkbox"] {
  margin-right: 5px;
}

.date-filter-menu {
  height: auto;
  background-color: #fff;
  border: 1px solid #7474778f;
  border-radius: 0;
}

.date-filter-menu > div {
  flex: 1 1;
  margin-right: 10px;
}

.date-filter-menu label {
  display: block;
  margin-bottom: 5px;
}

.date-filter-menu input[type="text"] {
  border-radius: 0;
  border: 1px solid #000;
  padding: 5px;
  width: 100%;
}

.date-filter-menu .react-datepicker-wrapper {
  width: 100%;
}

.date-filter-menu .react-datepicker__input-container {
  width: 100%;
}
/* Filter clear */

.btn-clearfilter {
  font-size: 14px;
  color: #5d5c5c;
  cursor: pointer;
}

.btn-clearfilter i {
  margin-right: 5px;
}

/* Toggle filter */

.toggle-filter-btn {
  display: none;
  background-color: #759eb8;
  color: white;
  border: none;
  padding: 10px 15px;
  font-size: 16px;
  margin-bottom: 10px;
  border-radius: 4px;
  cursor: pointer;
  align-items: center;
  gap: 8px;
}

.toggle-filter-btn svg {
  margin-right: 8px;
}

/* Responsive mobile */

@media (max-width: 850px) {
  .toggle-filter-btn {
    display: flex;
  }

  .filter-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    width: 100%;
    padding: 10px;
    background-color: #f8f8f8;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .filter-button-container {
    width: 100%;
    position: relative;
  }

  .filter-button {
    width: 100%;
    justify-content: space-between;
    text-align: left;
  }

  .filter-menu,
  .filter-menu-picker {
    width: 100% !important;
    left: 0;
    top: calc(100% + 4px);
    max-width: 100%;
  }

  .filter-button-container .css-1fdsijx-ValueContainer,
  .filter-button-container .css-13cymwt-control {
    min-width: auto !important;
    width: 100% !important;
    box-sizing: border-box;
  }

  .filter-offices .css-1nmdiq5-menu {
    min-width: auto !important;
    width: 100% !important;
  }
}

.filter-menu,
.filter-menu-picker {
  display: none;
}

.filter-menu.active,
.filter-menu-picker.active {
  display: block;
}

/* responsive desktop */
@media (min-width: 851px) {
  .filter-menu-picker.date-filter-menu.active {
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: flex-start;
    justify-content: space-between;
    width: 300px;
  }

  .filter-menu-picker.date-filter-menu > div {
    flex: 1 1;
    margin-right: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Home/FilterComponent/FilterComponent.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA,iBAAiB;;AAEjB;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,OAAO;IACP,qBAAqB;IACrB,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;AACF","sourcesContent":["/* Estructura */\n.filter-container {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  z-index: 1;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.filter-container.hidden {\n  display: none !important;\n}\n\n.filter-container.visible {\n  display: flex !important;\n}\n\n.filter-button-container {\n  position: relative;\n  width: fit-content;\n}\n\n.filter-button {\n  position: relative;\n  background-color: #c1d8f1;\n  color: black;\n  border: none;\n  border-radius: 0;\n  padding: 5px 15px;\n  cursor: pointer;\n  outline: none;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.filter-button:hover {\n  background-color: #b8cee6;\n}\n\n.filter-button i {\n  margin-left: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* React select */\n\n.filter-button-container .css-13cymwt-control {\n  position: relative;\n  background-color: #c1d8f1;\n  color: black;\n  border: none;\n  border-radius: 0;\n  cursor: pointer;\n  outline: none;\n  font-size: 15px;\n  display: flex;\n  justify-content: space-around;\n  min-height: 30px;\n}\n\n.filter-button-container .css-1fdsijx-ValueContainer {\n  color: black;\n  min-width: 120px;\n}\n\n.filter-offices .css-1nmdiq5-menu {\n  color: black;\n  min-width: 220px;\n}\n\n.filter-button-container .css-1jqq78o-placeholder {\n  color: black;\n}\n\n.filter-button-selected:hover {\n  background-color: #b8cee6;\n}\n\n.filter-button-selected i {\n  margin-left: 10px;\n}\n\n/* Dropdown */\n.filter-menu {\n  position: absolute;\n  top: 100%;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 10px;\n  display: block;\n  z-index: 1;\n  width: 200px;\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: opacity 0.2s ease-in-out;\n}\n\n.filter-menu label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.filter-menu input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.filter-menu-picker {\n  position: absolute;\n  top: 100%;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  display: none;\n  z-index: 1;\n  width: 200px;\n  max-height: 300px;\n}\n\n.filter-menu-picker label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.filter-menu-picker input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.date-filter-menu {\n  height: auto;\n  background-color: #fff;\n  border: 1px solid #7474778f;\n  border-radius: 0;\n}\n\n.date-filter-menu > div {\n  flex: 1;\n  margin-right: 10px;\n}\n\n.date-filter-menu label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.date-filter-menu input[type=\"text\"] {\n  border-radius: 0;\n  border: 1px solid #000;\n  padding: 5px;\n  width: 100%;\n}\n\n.date-filter-menu .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.date-filter-menu .react-datepicker__input-container {\n  width: 100%;\n}\n/* Filter clear */\n\n.btn-clearfilter {\n  font-size: 14px;\n  color: #5d5c5c;\n  cursor: pointer;\n}\n\n.btn-clearfilter i {\n  margin-right: 5px;\n}\n\n/* Toggle filter */\n\n.toggle-filter-btn {\n  display: none;\n  background-color: #759eb8;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  font-size: 16px;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  align-items: center;\n  gap: 8px;\n}\n\n.toggle-filter-btn svg {\n  margin-right: 8px;\n}\n\n/* Responsive mobile */\n\n@media (max-width: 850px) {\n  .toggle-filter-btn {\n    display: flex;\n  }\n\n  .filter-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n    width: 100%;\n    padding: 10px;\n    background-color: #f8f8f8;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    box-sizing: border-box;\n  }\n\n  .filter-button-container {\n    width: 100%;\n    position: relative;\n  }\n\n  .filter-button {\n    width: 100%;\n    justify-content: space-between;\n    text-align: left;\n  }\n\n  .filter-menu,\n  .filter-menu-picker {\n    width: 100% !important;\n    left: 0;\n    top: calc(100% + 4px);\n    max-width: 100%;\n  }\n\n  .filter-button-container .css-1fdsijx-ValueContainer,\n  .filter-button-container .css-13cymwt-control {\n    min-width: auto !important;\n    width: 100% !important;\n    box-sizing: border-box;\n  }\n\n  .filter-offices .css-1nmdiq5-menu {\n    min-width: auto !important;\n    width: 100% !important;\n  }\n}\n\n.filter-menu,\n.filter-menu-picker {\n  display: none;\n}\n\n.filter-menu.active,\n.filter-menu-picker.active {\n  display: block;\n}\n\n/* responsive desktop */\n@media (min-width: 851px) {\n  .filter-menu-picker.date-filter-menu.active {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 300px;\n  }\n\n  .filter-menu-picker.date-filter-menu > div {\n    flex: 1;\n    margin-right: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
